module.exports = __webpack_public_path__ + "img/demo_img2.c64dafb3.jpeg";